module.exports = __webpack_public_path__ + "img/telegram.b3d00a40.svg";